<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M40 13H35.64C35.86 12.38 36 11.7 36 11C36 7.68 33.32 5 30 5C27.9 5 26.08 6.08 25 7.7L24 9.04L23 7.68C21.92 6.08 20.1 5 18 5C14.68 5 12 7.68 12 11C12 11.7 12.14 12.38 12.36 13H8C5.78 13 4.02 14.78 4.02 17L4 39C4 41.22 5.78 43 8 43H40C42.22 43 44 41.22 44 39V17C44 14.78 42.22 13 40 13ZM30 9C31.1 9 32 9.9 32 11C32 12.1 31.1 13 30 13C28.9 13 28 12.1 28 11C28 9.9 28.9 9 30 9ZM18 9C19.1 9 20 9.9 20 11C20 12.1 19.1 13 18 13C16.9 13 16 12.1 16 11C16 9.9 16.9 9 18 9ZM40 39H8V35H40V39ZM40 29H8V17H18.16L14 22.66L17.24 25L24 15.8L30.76 25L34 22.66L29.84 17H40V29Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
